module.exports = __webpack_public_path__ + "static/img/firouzja.f449c1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/firouzja.jpg
// module id = 470
// module chunks = 11